var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    _vm._l(_vm.refs, function (ref, index) {
      return _c(
        "span",
        { key: index },
        [
          ref.component
            ? _c(
                ref.component,
                _vm._b({ tag: "component" }, "component", ref.props, false)
              )
            : _c("span", [_vm._v(_vm._s(ref))]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }